import { ScienceProject } from '../types/interfaces'

export default [
  {
    name: 'Physik und Technologie glasartiger Materialien',
    description:
      'Glasartige Materialien auf Basis von Silizium- und Phosphoroxiden bilden die Grundlage der modernen Optoelektronik. Ihre einzigartige, amorphe Struktur ermöglicht eine weitreichende Modifikation der physikochemischen Eigenschaften. Im Rahmen meiner wissenschaftlichen Tätigkeit synthetisiere ich neuartige Silikat-Phosphat-Gläser und untersuche umfassend ihre elektrischen und optischen Eigenschaften, was für die Entwicklung einer neuen Generation von Lichtwellenleitern und Sensoren von entscheidender Bedeutung ist.',
    time: '2025+',
  },
  {
    name: 'Ionenleitfähigkeit in Glaskeramik-Verbundwerkstoffen',
    description:
      'Glaskeramik-Verbundwerkstoffe mit hoher Ionenleitfähigkeit (Li+, Na+, K+, O2-) sind ein Schlüsselelement der Revolution im Bereich der Energiespeicherung und -umwandlung. Sie stellen eine sichere Alternative zu flüssigen Komponenten in Festkörperbatterien der nächsten Generation und Brennstoffzellen dar. Meine Forschung konzentriert sich auf die Optimierung des Ionentransports in diesen Strukturen durch die Analyse ihrer Mikrostruktur und Impedanzmessungen.',
    time: '2025+',
  },
  {
    name: 'Modellierung von Ionenprozessen',
    description:
      'Der Einsatz künstlicher Intelligenz revolutioniert die moderne Werkstofftechnik. Die Verwendung von neuronalen Netzen und maschinellem Lernen (ML-Potenziale) ermöglicht die Simulation der Molekulardynamik und des Ionentransports in glasartigen Materialien mit Quantengenauigkeit bei minimalen Rechenkosten. Das Projekt umfasst die Implementierung von Algorithmen für maschinelles Lernen zur Vorhersage der strukturellen und diffusiven Eigenschaften von Gläsern.',
    time: '2026+',
  },
  {
    name: 'Beschleuniger und nukleare Apparaturen',
    description:
      'Beschleuniger sind Geräte, die zur Beschleunigung von Teilchen und zur Emission von Strahlung verwendet werden. Sie finden viele Anwendungen in der Industrie und in der wissenschaftlichen Forschung, wo sie unter anderem zur Ionenimplantation oder zur Erkennung von Materialfehlern eingesetzt werden. Sie werden auch in der Krebstherapie eingesetzt. Die Konstruktion nuklearer Apparaturen beinhaltet sowohl den Einsatz von Industrieelektronik als auch das Erlernen von Techniken wie Ionenpumpen, Vakuumöfen und hydraulischen Kühlsystemen. Während meines Praktikums lernte ich den Aufbau und die Möglichkeiten von Beschleunigern kennen und erstellte Software zu deren Steuerung.',
    time: '2025',
    label: {
      text: 'Praktikum',
      color: '#00647D',
    },
  },
  {
    name: 'Superionenleiter',
    description:
      'Superionenleiter sind Materialien, die eine hohe Ionenleitfähigkeit aufweisen, was sie für Anwendungen in Batterien und Brennstoffzellen vielversprechend macht. Während eines Sommer-Minipraktikums am CEZAMAT Zentrum für fortschrittliche Materialien und Technologien stellten wir Proben solcher Materialien her und untersuchten dann ihre Eigenschaften mit Techniken wie der Röntgenbeugung (XRD).',
    time: 'Sommer 2024',
    label: {
      text: 'Sommerprojekt',
      color: '',
    },
  },
  {
    name: 'Wismutglas',
    description:
      'Während eines Sommer-Minipraktikums an der Fakultät für Physik der Technischen Universität Warschau befassten wir uns mit der Synthese von Wismutglas und dem Kennenlernen der Eigenschaften von Materialien mit kristalliner und amorpher Struktur. Anschließend untersuchten wir seine elektrischen, thermischen und strukturellen Eigenschaften mit besonderem Schwerpunkt auf Phasenübergängen, die dieses Material temperaturabhängig erfährt, wie z.B. Kristallisation.',
    time: 'Sommer 2024',
    label: {
      text: 'Sommerprojekt',
      color: '',
    },
  },
] as ScienceProject[]
